/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.workflows').controller('WorkflowsPropertiesSectionController',
    function($scope, $q, SearchFilterService){
        var self=this;

        self.available = {
            statuses: []
        };

        self.searchCriteria = {
            statuses: []
        };

        var retrieveStatuses = function () {
            var statusesPromise = SearchFilterService.getWorkflowStatuses();
            $q.all({
                statuses: statusesPromise
            }).then(function(data) {
                self.available.statuses = data.statuses;

                self.searchCriteria.statuses = SearchFilterService.getObjectsFromPathProp(self.available.statuses, 'id', 'status');
            });
        };

        $scope.$on('modal.closing', function () {
            SearchFilterService.workflowSearchCriteria.status = SearchFilterService.extractQueryProp(self.searchCriteria.statuses, 'id');
        });

        retrieveStatuses();
    });
